<template>
  <div
    class="content content-login-block w-100 h-100 d-flex justify-content-center align-items-center flex-column position-relative"
  >
    <div class="logo-top">
      <router-link to="/">
        <img :src="logo" class="logo-top my-5" />
      </router-link>
    </div>
    <div class="row content-body login-body align-items-center">
      <div class="col-lg-12">
        <div class="row gap-3 flex-nowrap cards-login">
          <div class="col-lg-4 col-5 px-0">
            <div class="card-login text-center">
              <router-link to="/login-veterinaire" class="icon-wrapper d-block">
                <img :src="icon1"  />
              </router-link>
            </div>
          </div>
          <div class="col-lg-4 col-5 px-0">
            <div class="card-login text-center">
              <img :src="checked" class="checked-card" />

              <router-link to="/login-proprietaire" class="icon-wrapper d-block selected">
                <img :src="icon2"  />
              </router-link>
            </div>
          </div>
        </div>

        <p class="title mt-3 mb-3" v-html="$sanitize.sanitizeI18nContent($t('proprietaire_connect.title'))"></p>

        <div class="row justify-content-center">
          <div class="col-lg-10 my-2">
            <div class="mx-auto form-login d-flex flex-column">
              <input
                type="text"
                v-model="email"
                class="mb-4"
                :class="{ error: errorEmail }"
                :placeholder="$t('proprietaire_connect.placeholders.email')"
              />
              <span v-if="errorEmail" class="error-message mb-4">{{ errorEmail }}</span>
              <input
                type="password"
                v-model="password"
                class="mb-4"
                :class="{ error: errorPassword }"
                :placeholder="$t('proprietaire_connect.placeholders.password')"
              />
              <span v-if="errorPassword" class="error-message mb-4">{{ errorPassword }}</span>
              <button
                class="btn text-white btn-login w-100 mb-4"
                id="login"
                @click.prevent="handleLogin"
                :disabled="isLoading"
              >
                {{ $t("proprietaire_connect.buttons.login") }}
              </button>
              <span v-if="errorMessage" class="error-message mb-4">{{ errorMessage }}</span>
              <div class="row">
                <label class="checkbox-container col-lg-6 col-md-6 col-6 col-sm-6">
                  <input type="checkbox" />
                  <span class="checkmark"></span>
                  <label class="mx-2">{{ $t("proprietaire_connect.labels.remember_me") }}</label>
                </label>
                <router-link to="/forget-password-proprietaire" class="link-forget col-lg-6 col-md-6 col-6 col-sm-6">{{
                  $t("proprietaire_connect.links.forgot_password")
                }}</router-link>
              </div>
              <router-link to="/create-compte" class="my-4">
                <button class="btn btn-register w-100">{{ $t("proprietaire_connect.buttons.register") }}</button>
              </router-link>
              <div v-if="successMessage" class="alert alert-success">
                <span class="success-message mt-4">{{ successMessage }}</span>
              </div>
              <div v-if="errorVerifMessage" class="alert alert-error">
                <span class="error-message mt-4">{{ errorVerifMessage }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { login } from "@/api/auth";
  import { AccountVerify } from "@/api/auth";
  import icon1 from "@/assets/images/doctor.svg";
  import icon2 from "@/assets/images/animaux.svg";
  import checked from "@/assets/images/check-box.png";
  import logo from "@/assets/images/2_LOGO - COULEURS-bg-b.png";
  import { useRegisterStore } from "@/stores/register";
  import { useAuthStore } from "@/stores/authStore";
  import AuthService from "@/services/authService";
  import { extractUserFromToken, validateUserRole } from "@/utils/jwtHelpers";
  import $ from "jquery";

  export default {
    name: "ProprietaireLogin",
    data() {
      return {
        icon1,
        icon2,
        checked,
        logo,
        email: "",
        password: "",
        type: "clients",
        errorMessage: null,
        errorEmail: "",
        errorPassword: "",
        isLoading: false,
        successMessage: "",
        errorVerifMessage: "",
        canStore: true,
      };
    },
    mounted() {

      const registerStore = useRegisterStore();
      registerStore.clearRegistrationData();
      if (typeof this.$route.query.token_verification !== "undefined") {
        var token_id = this.$route.query.token_verification;
        AccountVerify(token_id)
          .then(() => {
            this.successMessage = this.$t("proprietaire_connect.success.account_activated");
            setTimeout(() => {
              this.successMessage = "";
            }, 6000);
          })
          .catch(() => {
            this.errorVerifMessage = this.$t("proprietaire_connect.errors.token_invalid");
            setTimeout(() => {
              this.errorVerifMessage = "";
            }, 6000);
          });
      }
      if (AuthService.isAuthenticated()) {
        this.$router.push("/dashboard");
      }
    },
    methods: {
      async handleLogin() {
        this.errorMessage = "";
        this.errorEmail = "";
        this.errorPassword = "";
        this.canStore = true;
        this.isLoading = true;
        var spinner =
          '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Authentification en cours ...';
        $("#login").html(spinner);
        this.CheckValidate();
        if (!this.canStore) {
          this.isLoading = false;
          $("#login").text(this.$t("proprietaire_connect.buttons.login"));
          return;
        }

        try {
          const res = await login(this.email, this.password, this.type);
          const authStore = useAuthStore();
          const registerStore = useRegisterStore();
          const token = res.data.token;
          const jwtUserData = extractUserFromToken(token);
          if (!jwtUserData) {
            console.error("Erreur : Token JWT invalide ou corrompu");
            throw new Error("Authentification échouée - Token invalide");
          }
          if (!validateUserRole(token, "client")) {
            console.warn("Accès refusé : utilisateur sans droits propriétaire");
            this.errorMessage = this.$t("proprietaire_connect.errors.access_denied");
            this.isLoading = false;
            $("#login").text(this.$t("proprietaire_connect.buttons.login"));
            return;
          }

          const user = {
            id: jwtUserData.id,
            email: jwtUserData.email,
            fullName: jwtUserData.fullName,
            firstName: jwtUserData.firstName,
            lastName: jwtUserData.lastName,
            gender: jwtUserData.gender,
            role: "client",
          };

          authStore.setToken(token);
          authStore.setUser(user);
          registerStore.setUser(user);

          const data_proprietaire = {
            lastName: jwtUserData.lastName,
            firstName: jwtUserData.firstName,
            fullName: jwtUserData.fullName,
            email: jwtUserData.email,
            phone: null,
            postcode: null,
            street: null,
            city: null,
            customer_infos: {
              id: jwtUserData.id,
              email: jwtUserData.email,
              fullName: jwtUserData.fullName,
              firstName: jwtUserData.firstName,
              lastName: jwtUserData.lastName,
              gender: jwtUserData.gender,
            },
            address_infos: null,
          };
          registerStore.setInfoveterinaire(data_proprietaire);
          $("#login").text(this.$t("proprietaire_connect.buttons.login"));
          this.isLoading = false;
          this.$router.push("/dashboard");
        } catch (error) {
          console.error("Erreur lors du login:", error);
          this.isLoading = false;
          
          // Gestion spécifique du profil incomplet
          if (error.response && error.response.data && error.response.data.type === "access_denied_profile_incomplete_esupplyvet") {
            const registerStore = useRegisterStore();
            registerStore.setUser({ 
              email: this.email
            });
            registerStore.setProfileIncomplete(true);
            
            
            this.$router.push("/create-compte");
            return;
          }
          
          this.errorMessage = error.response
            ? error.response.data.message === "Bad Request"
              ? this.$t("proprietaire_connect.errors.incorrect_credentials")
              : error.response.data.message
            : this.$t("proprietaire_connect.errors.login_failed");
          $("#login").text(this.$t("proprietaire_connect.buttons.login"));
        }
      },
      CheckValidate() {
        const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (this.email == "") {
          this.errorEmail = this.$t("proprietaire_connect.errors.email_required");
          this.canStore = false;
        } else {
          if (!regexEmail.test(this.email)) {
            this.errorEmail = this.$t("proprietaire_connect.errors.email_invalid");
            this.canStore = false;
          }
        }

        if (this.password == "") {
          this.errorPassword = this.$t("proprietaire_connect.errors.password_required");
          this.canStore = false;
        }

        if (!this.canStore) {
          this.isLoading = false;
          $("#login").text(this.$t("proprietaire_connect.buttons.login"));
        }
      },
    },
  };
</script>
<style scoped>
  .login-body {
    position: relative;
    height: 100%;
  }
  .top-logo {
    text-align: end;
  }
  .top-logo img {
    margin-right: 20px;
  }

  .login-body .title {
    color: #1e347d;
    font-size: 22px;
    font-weight: bold;
    text-align: center;
    line-height: 29px;
  }
  .login-body .slogan {
    font-size: 17px;
    color: #1e347d;
    text-align: center;
  }
  .cards-login {
    justify-content: center;
  }
  .card-login .title {
    color: #1e347d;
    font-size: 23px;
    font-weight: bold;
  }
  .login-body .icon-wrapper {
    margin: 0 auto;
    border: 2px solid #1e347d;
    border-radius: 10px;
  }
  .login-body .icon-wrapper.selected {
    background: #c9cfde 0% 0% no-repeat padding-box;
  }
  .login-body .checked-card {
    position: absolute;
    top: 5%;
  }
  .form-login {
    input {
      height: 40px;
      background: #ffffff 0% 0% no-repeat padding-box;
      border: 2px solid #aeb1ba;
      border-radius: 76px;
      padding: 0 20px;
      transition: all 0.3s ease-in-out;
    }
    input:focus {
      border-color: #c9cfde;
      outline: none;
    }
  }
  .btn-login {
    background-color: #ec621a !important;
    border-radius: 76px !important;
    font-size: 16px;
    text-align: center;
    font-weight: 600;
    letter-spacing: 0px;
  }
  .checkbox-container {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 16px;
  }

  .checkbox-container input {
    display: none; /* Cache l'input natif */
  }

  .checkmark {
    width: 22px;
    height: 22px;
    border: 2px solid #666;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    transition: all 0.3s ease-in-out;
    position: relative;
  }

  .checkmark::after {
    content: "";
    width: 10px;
    height: 15px;
    border: solid white;
    border-width: 0 3px 3px 0;
    transform: rotate(45deg);
    opacity: 0;
    transition: all 0.3s ease-in-out;
  }
  /* Animation au clic checkbox*/
  .checkbox-container input:checked + .checkmark {
    background-color: #ec621a;
    border-color: #ec621a;
    transform: scale(1.1);
  }

  .checkbox-container input:checked + .checkmark::after {
    opacity: 1;
  }

  /* Effet rebond */
  .checkbox-container input:checked + .checkmark {
    animation: bounce 0.3s ease-in-out;
  }

  @keyframes bounce {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.3);
    }
    100% {
      transform: scale(1.1);
    }
  }
  .logo {
    width: 170px;
    height: 35px;
  }
  .link-forget {
    color: #1e347d;
    font-size: 15px;
    font-weight: 600;
    text-align: right;
  }
  .btn-register,
  .btn-register:hover {
    background: #c9cfde 0% 0% no-repeat padding-box;
    border-radius: 76px;
    font-size: 16px;
    text-align: center;
    font-weight: bold;
    letter-spacing: 0px;
    color: #1e347d;
  }
  .error {
    border-color: red !important;
  }
  .error-message {
    color: red;
    margin-left: 8px;
  }
  .alert {
    border-radius: 4px;
    color: #515a6e;
    font-size: 18px;
    line-height: 16px;
    margin-bottom: 10px;
    position: relative;
  }
  .alert-success {
    background-color: #edfff3;
    border: 1px solid #8ce6b0;
  }
  .success-message,
  .error-message {
    margin-left: 8px;
  }
  .alert-error {
    background-color: #ffefe6;
    border: 1px solid #ffb08f;
  }
</style>